import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-race-entry',
  templateUrl: './edit-race-entry.component.html',
  styleUrls: ['./edit-race-entry.component.scss']
})
export class EditRaceEntryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
